const emojis = ['⭐️', '📍'];

const tagFilterConditions = {
  twNorth: [
    'tw-klu',
    'tw-tph',
    'tw-tpe',
    'tw-tyc',
    'tw-hsh',
    'tw-iln',
    'tw-mal',
  ],
  twCenter: ['tw-mal', 'tw-txg', 'tw-nto', 'tw-cwh', 'tw-ylh'],
  twSouth: ['tw-tnn', 'tw-chy', 'tw-khh', 'tw-iuh'],
  twEast: ['tw-hwa', 'tw-ttt'],
  twIsland: ['tw-peh', 'tw-lnn', 'tw-kmn'],
};

export { emojis, tagFilterConditions };
